/* ONAIR V11: mobile navigation access and direct-to-comparison entry. */
(() => {
  'use strict';
  function setupNavigation() {
    document.querySelectorAll('mobile-menu [data-menu-item]').forEach((item) => {
      const trigger = item.querySelector(':scope > button.mobile-menu--link[aria-controls]');
      if (!trigger || trigger.dataset.onairV11Ready === '1') return;
      trigger.dataset.onairV11Ready = '1';
      const update = () => trigger.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      const observer = new MutationObserver(update);
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        item.classList.add('active');
        update();
      });
      update();
    });
  }
  function openComparison() {
    if (window.location.hash !== '#onair-management-comparison') return;
    const panel = document.getElementById('onair-management-comparison');
    if (!panel) return;
    panel.open = true;
    setTimeout(() => panel.scrollIntoView({ block: 'start', behavior: 'auto' }), 90);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { setupNavigation(); openComparison(); }, { once: true });
  } else { setupNavigation(); openComparison(); }
  window.addEventListener('hashchange', openComparison);
  window.addEventListener('load', openComparison, { once: true });
  document.addEventListener('shopify:section:load', () => { setupNavigation(); openComparison(); });
})();
